import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ISignIn } from '../../interfaces/interface';
import { GetUserDTO, SignInDTO } from '../../dtos/dto';
import { IChangePassword } from '../patient/patient.interface';

@Injectable({
  providedIn: 'root',
})
export class UserApi {
  private readonly apiUrl: string = environment.apiUrl;

  constructor(private readonly http: HttpClient) {}

  signIn(body: ISignIn): Observable<SignInDTO> {
    return this.http.post<SignInDTO>(this.apiUrl + '/user/sign-in', body);
  }

  getUser(): Observable<GetUserDTO> {
    return this.http.get<GetUserDTO>(this.apiUrl + '/user/me');
  }

  changePassword(passwordInput: IChangePassword): Observable<GetUserDTO> {
    return this.http.patch<GetUserDTO>(this.apiUrl + '/user/change-password', passwordInput);
  }
}
